export default __webpack_public_path__ + "static/media/3stepweightloss_2@2x.d01c48dc.jpg";